module.exports = __webpack_public_path__ + "static/media/zapsplat_cartoon_twang_impact_thud_wobble_45700.6672e2f1.mp3";